import Comment from '../Comment/Comment';
import './Replies.css';
const Replies = ({replies,currentUser,id,handleData})=>{
    return (
    <div className='replies'> 
        {
        replies.map(reply=>
            <Comment comment={reply} currentUser={currentUser} key={reply.id} id={id} handleData={handleData}/>
        )}
    </div>
    )

}
export default Replies;